// @ts-nocheck
import AppConfigs from "configs/env";
import { END_POINTS } from "constants/apiUrl";
import { APIUtils } from "utils";

export const validateCampaignApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_CAMPAIGN_INFO, {
    params: payload,
  });
};

export const validateCodeApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_CODE + `/${payload}`, {
  
  });
};

export const OTPLogApi = (payload) => {
  return APIUtils.post(END_POINTS.OTP_LOG_URL, {
    body: payload,
  });
};

export const requestOTPApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_OTP, {
    body: payload,
  });
};

export const verifyOTPApi = (payload) => {
  return APIUtils.post(END_POINTS.VERIFY_OTP, {
    body: payload,
  });
};

export const requestLoginApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_LOGIN_URL, {
    body: payload,
  });
};

export const updateUserInfoApi = (payload) => {
  return APIUtils.post(END_POINTS.UPDATE_USER_INFO_URL, {
    body: payload,
  });
};

export const requestGigyaApi = (payload) => {
  return APIUtils.post(END_POINTS.REQUEST_GIGYA_URL, {
    body: payload,
  });
};

export const exchangeCodeApi = (payload) => {
  return APIUtils.post(END_POINTS.EXCHANGE_CODE_URL, {
    body: payload,
  });
};

export const getStoreByPhoneApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_STORE_BY_PHONE_URL, {
    params: payload,
  });
};

export const getCampaignInfoApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_CAMPAIGN_INFO, {
    params: payload,
  });
};

export const submitWishApi = (payload) => {
  return APIUtils.post(END_POINTS.ADD_GREETING, {
    body: payload,
  });
};

export const getGiftSummaryApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_GIFT_SUMMARY, {
    params: payload,
  });
};

export const takeGiftApi = (payload) => {
  return APIUtils.post(END_POINTS.TAKE_GIFT, {
    body: payload,
  });
};

export const getBlockListApi = (payload) => {
  return APIUtils.get(END_POINTS.GET_BLOCK_LIST);
};

